import { DataTable } from "../components/DataTable";
import { PipelineCards } from "../components/PipelineCards";

export function PosTab() {
  return (
    <div className="space-y-4">
      <PipelineCards />
      <DataTable table="purchase-orders" title="Purchase orders" lens="po" />
    </div>
  );
}
